// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__V7h6t","link":"Nav_link__9aBVK","spring":"Nav_spring__mWIvU","searchContainer":"Nav_searchContainer__joG42","searchText":"Nav_searchText__rhs2-"};